import { useState, useMemo } from 'react';

const FORM_URL = 'https://readdy.ai/api/form/d69s8qlt1k61917cme7g';

interface ClassSlot {
  day: string;
  dayLabel: string;
  color: string;
  time: string;
  className: string;
  maxCapacity: number;
}

const CLASS_SLOTS: ClassSlot[] = [
  { day: 'mon', dayLabel: '月', color: 'from-[#FF6B35] to-[#FF8C5A]', time: '16:30〜17:15', className: '園児クラス（年長）', maxCapacity: 6 },
  { day: 'mon', dayLabel: '月', color: 'from-[#FF6B35] to-[#FF8C5A]', time: '17:30〜18:15', className: '1・2年生コース', maxCapacity: 6 },
  { day: 'tue', dayLabel: '火', color: 'from-[#0EA5E9] to-[#38BDF8]', time: '17:00〜17:45', className: '3・4年生スポーツコース', maxCapacity: 6 },
  { day: 'tue', dayLabel: '火', color: 'from-[#0EA5E9] to-[#38BDF8]', time: '18:10〜18:55', className: '5・6年生スポーツコース', maxCapacity: 6 },
  { day: 'thu', dayLabel: '木', color: 'from-[#FF6B35] to-[#FF8C5A]', time: '16:30〜17:15', className: '3〜6年生運動苦手克服コース', maxCapacity: 6 },
  { day: 'fri', dayLabel: '金', color: 'from-[#0EA5E9] to-[#38BDF8]', time: '16:30〜17:15', className: '園児クラス（年長）', maxCapacity: 6 },
  { day: 'fri', dayLabel: '金', color: 'from-[#0EA5E9] to-[#38BDF8]', time: '17:30〜18:15', className: '4〜6年生体幹TRスペシャル', maxCapacity: 6 },
  { day: 'sun', dayLabel: '日', color: 'from-[#FF6B35] to-[#FF8C5A]', time: '19:00〜19:50', className: 'ジュニアサッカー特別コース（4・5・6年生）', maxCapacity: 8 },
];

const DAY_MAP: Record<number, string> = {
  0: 'sun',
  1: 'mon',
  2: 'tue',
  4: 'thu',
  5: 'fri',
};

// モックの予約済み数（実際にはバックエンドから取得）
const MOCK_BOOKED: Record<string, number> = {
  // 2026年3月 - 日曜日
  '2026-03-01_19:00〜19:50_ジュニアサッカー特別コース（4・5・6年生）': 3,
  '2026-03-08_19:00〜19:50_ジュニアサッカー特別コース（4・5・6年生）': 5,
  '2026-03-15_19:00〜19:50_ジュニアサッカー特別コース（4・5・6年生）': 2,
  '2026-03-22_19:00〜19:50_ジュニアサッカー特別コース（4・5・6年生）': 6,
  '2026-03-29_19:00〜19:50_ジュニアサッカー特別コース（4・5・6年生）': 4,
  // 2026年3月
  '2026-03-02_16:30〜17:15_園児クラス（年長）': 3,
  '2026-03-02_17:30〜18:15_1・2年生コース': 5,
  '2026-03-03_17:00〜17:45_3・4年生スポーツコース': 2,
  '2026-03-03_18:10〜18:55_5・6年生スポーツコース': 4,
  '2026-03-05_16:30〜17:15_3〜6年生運動苦手克服コース': 1,
  '2026-03-06_16:30〜17:15_園児クラス（年長）': 4,
  '2026-03-06_17:30〜18:15_4〜6年生体幹TRスペシャル': 3,
  '2026-03-09_16:30〜17:15_園児クラス（年長）': 2,
  '2026-03-09_17:30〜18:15_1・2年生コース': 1,
  '2026-03-10_17:00〜17:45_3・4年生スポーツコース': 5,
  '2026-03-10_18:10〜18:55_5・6年生スポーツコース': 3,
  '2026-03-12_16:30〜17:15_3〜6年生運動苦手克服コース': 4,
  '2026-03-13_16:30〜17:15_園児クラス（年長）': 2,
  '2026-03-13_17:30〜18:15_4〜6年生体幹TRスペシャル': 5,
  '2026-03-16_16:30〜17:15_園児クラス（年長）': 4,
  '2026-03-16_17:30〜18:15_1・2年生コース': 3,
  '2026-03-17_17:00〜17:45_3・4年生スポーツコース': 1,
  '2026-03-17_18:10〜18:55_5・6年生スポーツコース': 6,
  '2026-03-19_16:30〜17:15_3〜6年生運動苦手克服コース': 2,
  '2026-03-20_16:30〜17:15_園児クラス（年長）': 3,
  '2026-03-20_17:30〜18:15_4〜6年生体幹TRスペシャル': 1,
  '2026-03-23_16:30〜17:15_園児クラス（年長）': 0,
  '2026-03-23_17:30〜18:15_1・2年生コース': 2,
  '2026-03-24_17:00〜17:45_3・4年生スポーツコース': 3,
  '2026-03-24_18:10〜18:55_5・6年生スポーツコース': 1,
  '2026-03-26_16:30〜17:15_3〜6年生運動苦手克服コース': 5,
  '2026-03-27_16:30〜17:15_園児クラス（年長）': 6,
  '2026-03-27_17:30〜18:15_4〜6年生体幹TRスペシャル': 2,
  '2026-03-30_16:30〜17:15_園児クラス（年長）': 1,
  '2026-03-30_17:30〜18:15_1・2年生コース': 4,
  '2026-03-31_17:00〜17:45_3・4年生スポーツコース': 2,
  '2026-03-31_18:10〜18:55_5・6年生スポーツコース': 3,
  // 2026年4月 - 日曜日
  '2026-04-05_19:00〜19:50_ジュニアサッカー特別コース（4・5・6年生）': 3,
  '2026-04-12_19:00〜19:50_ジュニアサッカー特別コース（4・5・6年生）': 4,
  '2026-04-19_19:00〜19:50_ジュニアサッカー特別コース（4・5・6年生）': 6,
  '2026-04-26_19:00〜19:50_ジュニアサッカー特別コース（4・5・6年生）': 2,
  // 2026年4月
  '2026-04-02_16:30〜17:15_3〜6年生運動苦手克服コース': 1,
  '2026-04-03_16:30〜17:15_園児クラス（年長）': 3,
  '2026-04-03_17:30〜18:15_4〜6年生体幹TRスペシャル': 2,
  '2026-04-06_16:30〜17:15_園児クラス（年長）': 2,
  '2026-04-06_17:30〜18:15_1・2年生コース': 3,
  '2026-04-07_17:00〜17:45_3・4年生スポーツコース': 4,
  '2026-04-07_18:10〜18:55_5・6年生スポーツコース': 1,
  '2026-04-09_16:30〜17:15_3〜6年生運動苦手克服コース': 3,
  '2026-04-10_16:30〜17:15_園児クラス（年長）': 5,
  '2026-04-10_17:30〜18:15_4〜6年生体幹TRスペシャル': 4,
  '2026-04-13_16:30〜17:15_園児クラス（年長）': 1,
  '2026-04-13_17:30〜18:15_1・2年生コース': 2,
  '2026-04-14_17:00〜17:45_3・4年生スポーツコース': 6,
  '2026-04-14_18:10〜18:55_5・6年生スポーツコース': 2,
  '2026-04-16_16:30〜17:15_3〜6年生運動苦手克服コース': 5,
  '2026-04-17_16:30〜17:15_園児クラス（年長）': 3,
  '2026-04-17_17:30〜18:15_4〜6年生体幹TRスペシャル': 6,
  '2026-04-20_16:30〜17:15_園児クラス（年長）': 4,
  '2026-04-20_17:30〜18:15_1・2年生コース': 1,
  '2026-04-21_17:00〜17:45_3・4年生スポーツコース': 2,
  '2026-04-21_18:10〜18:55_5・6年生スポーツコース': 5,
  '2026-04-23_16:30〜17:15_3〜6年生運動苦手克服コース': 2,
  '2026-04-24_16:30〜17:15_園児クラス（年長）': 6,
  '2026-04-24_17:30〜18:15_4〜6年生体幹TRスペシャル': 3,
  '2026-04-27_16:30〜17:15_園児クラス（年長）': 0,
  '2026-04-27_17:30〜18:15_1・2年生コース': 5,
  '2026-04-28_17:00〜17:45_3・4年生スポーツコース': 1,
  '2026-04-28_18:10〜18:55_5・6年生スポーツコース': 4,
  '2026-04-30_16:30〜17:15_3〜6年生運動苦手克服コース': 3,
};

// 表示可能な月の範囲（2026年3月と4月のみ）
const MIN_MONTH = new Date(2026, 2, 1); // 2026年3月
const MAX_MONTH = new Date(2026, 3, 1); // 2026年4月

function getBookedCount(dateStr: string, time: string, className: string): number {
  const key = `${dateStr}_${time}_${className}`;
  return MOCK_BOOKED[key] ?? Math.floor(Math.random() * 4);
}

function formatDate(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

function formatDateJP(d: Date): string {
  return `${d.getFullYear()}年${d.getMonth() + 1}月${d.getDate()}日`;
}

const WEEKDAY_LABELS = ['日', '月', '火', '水', '木', '金', '土'];

export default function TrialBookingSection() {
  const [currentMonth, setCurrentMonth] = useState(new Date(2026, 2, 1)); // 2026年3月スタート
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const [selectedSlot, setSelectedSlot] = useState<{ date: string; dateJP: string; slot: ClassSlot; remaining: number } | null>(null);
  const [formStep, setFormStep] = useState<'calendar' | 'form'>('calendar');
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');

  const calendarDays = useMemo(() => {
    const year = currentMonth.getFullYear();
    const month = currentMonth.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const startDow = firstDay.getDay();
    const days: (Date | null)[] = [];

    for (let i = 0; i < startDow; i++) {
      days.push(null);
    }
    for (let d = 1; d <= lastDay.getDate(); d++) {
      days.push(new Date(year, month, d));
    }
    return days;
  }, [currentMonth]);

  const canGoPrev = currentMonth.getFullYear() > MIN_MONTH.getFullYear() ||
    (currentMonth.getFullYear() === MIN_MONTH.getFullYear() && currentMonth.getMonth() > MIN_MONTH.getMonth());

  const canGoNext = currentMonth.getFullYear() < MAX_MONTH.getFullYear() ||
    (currentMonth.getFullYear() === MAX_MONTH.getFullYear() && currentMonth.getMonth() < MAX_MONTH.getMonth());

  const prevMonth = () => {
    if (canGoPrev) {
      setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1, 1));
      setSelectedDate(null);
      setSelectedSlot(null);
    }
  };

  const nextMonth = () => {
    if (canGoNext) {
      setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 1));
      setSelectedDate(null);
      setSelectedSlot(null);
    }
  };

  const getSlotsForDate = (date: Date) => {
    const dow = date.getDay();
    const dayKey = DAY_MAP[dow];
    if (!dayKey) return [];
    return CLASS_SLOTS.filter(s => s.day === dayKey);
  };

  const hasSlots = (date: Date) => {
    return getSlotsForDate(date).length > 0;
  };

  const handleDateClick = (date: Date) => {
    if (!hasSlots(date)) return;
    setSelectedDate(date);
    setSelectedSlot(null);
  };

  const handleSlotSelect = (slot: ClassSlot, remaining: number) => {
    if (remaining <= 0 || !selectedDate) return;
    setSelectedSlot({
      date: formatDate(selectedDate),
      dateJP: formatDateJP(selectedDate),
      slot,
      remaining,
    });
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!selectedSlot) return;

    const form = e.currentTarget;
    const formData = new FormData(form);
    setSubmitStatus('submitting');

    fetch(FORM_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
    })
      .then((res) => {
        if (res.ok) {
          setSubmitStatus('success');
          form.reset();
        } else {
          setSubmitStatus('error');
        }
      })
      .catch(() => {
        setSubmitStatus('error');
      });
  };

  const resetForm = () => {
    setSelectedDate(null);
    setSelectedSlot(null);
    setFormStep('calendar');
    setSubmitStatus('idle');
  };

  return (
    <section id="trial-booking" className="py-16 md:py-24 px-4 md:px-6 bg-gradient-to-br from-[#FFF5F0] via-white to-[#F0F9FF]">
      <div className="max-w-5xl mx-auto">
        {/* Header */}
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 bg-gradient-to-r from-[#FF6B35] to-[#FF8C5A] text-white px-4 md:px-5 py-2 md:py-2.5 rounded-full text-sm md:text-base font-bold shadow-lg mb-4 md:mb-6">
            <div className="w-2 md:w-2.5 h-2 md:h-2.5 bg-white rounded-full animate-pulse"></div>
            Web予約受付中
          </div>
          <h2 className="text-2xl md:text-4xl font-black text-gray-900 mb-3 md:mb-4 leading-tight">
            無料体験レッスン<br />申込フォーム 📝
          </h2>
          <p className="text-gray-600 text-sm md:text-base font-medium max-w-2xl mx-auto">
            カレンダーからご希望の日程を選んで、簡単にお申し込みいただけます。<br className="hidden md:block" />
            各クラス定員6名・残り枠をリアルタイムで確認できます。
          </p>
          <div className="text-xs text-gray-600 mt-3 font-bold bg-yellow-50 px-4 py-2 rounded-lg border border-yellow-200 inline-block">
            ※記載のクラスは4月からの新学年を基準としています。
          </div>
        </div>

        {/* Success Message */}
        {submitStatus === 'success' ? (
          <div className="bg-white rounded-2xl md:rounded-3xl p-8 md:p-12 shadow-xl border-2 border-[#06C755]/30 text-center">
            <div className="w-20 h-20 bg-gradient-to-br from-[#06C755] to-[#00B900] rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-check-line text-white text-4xl"></i>
            </div>
            <h3 className="text-2xl md:text-3xl font-black text-gray-900 mb-3">お申し込みありがとうございます！ 🎉</h3>
            <p className="text-gray-600 font-medium mb-2">体験レッスンのお申し込みを受け付けました。</p>
            <p className="text-gray-600 font-medium mb-6">担当者より確認のご連絡をさせていただきます。</p>
            <div className="bg-[#F0F9FF] rounded-xl p-4 mb-8 inline-block">
              <div className="text-sm text-gray-700 font-medium">
                <strong>予約内容：</strong>{selectedSlot?.dateJP} {selectedSlot?.slot.time} {selectedSlot?.slot.className}
              </div>
            </div>
            <div>
              <button
                onClick={resetForm}
                className="inline-flex items-center gap-2 bg-gradient-to-r from-[#FF6B35] to-[#FF8C5A] text-white font-bold px-8 py-3 rounded-full hover:shadow-xl hover:scale-105 transition-all whitespace-nowrap cursor-pointer shadow-lg"
              >
                <i className="ri-arrow-left-line"></i>
                カレンダーに戻る
              </button>
            </div>
          </div>
        ) : (
          <div className="grid md:grid-cols-5 gap-6 md:gap-8">
            {/* Calendar */}
            <div className="md:col-span-3 bg-white rounded-2xl md:rounded-3xl p-5 md:p-8 shadow-xl border-2 border-gray-100">
              {/* Month Navigation */}
              <div className="flex items-center justify-between mb-6">
                <button
                  onClick={prevMonth}
                  disabled={!canGoPrev}
                  className={`w-10 h-10 flex items-center justify-center rounded-full transition-colors ${
                    canGoPrev ? 'hover:bg-gray-100 cursor-pointer' : 'opacity-30 cursor-not-allowed'
                  }`}
                >
                  <i className="ri-arrow-left-s-line text-xl text-gray-700"></i>
                </button>
                <h3 className="text-lg md:text-xl font-black text-gray-900">
                  {currentMonth.getFullYear()}年{currentMonth.getMonth() + 1}月
                </h3>
                <button
                  onClick={nextMonth}
                  disabled={!canGoNext}
                  className={`w-10 h-10 flex items-center justify-center rounded-full transition-colors ${
                    canGoNext ? 'hover:bg-gray-100 cursor-pointer' : 'opacity-30 cursor-not-allowed'
                  }`}
                >
                  <i className="ri-arrow-right-s-line text-xl text-gray-700"></i>
                </button>
              </div>

              {/* Weekday Headers */}
              <div className="grid grid-cols-7 gap-1 mb-2">
                {WEEKDAY_LABELS.map((label, i) => (
                  <div
                    key={label}
                    className={`text-center text-xs font-bold py-2 ${
                      i === 0 ? 'text-red-400' : i === 6 ? 'text-[#0EA5E9]' : 'text-gray-500'
                    }`}
                  >
                    {label}
                  </div>
                ))}
              </div>

              {/* Calendar Grid */}
              <div className="grid grid-cols-7 gap-1">
                {calendarDays.map((date, idx) => {
                  if (!date) {
                    return <div key={`empty-${idx}`} className="h-12 md:h-14"></div>;
                  }
                  const hasClass = hasSlots(date);
                  const isSelected = selectedDate && formatDate(selectedDate) === formatDate(date);
                  const dow = date.getDay();
                  const slots = getSlotsForDate(date);
                  const dateStr = formatDate(date);

                  let allFull = true;
                  if (hasClass) {
                    slots.forEach(s => {
                      const booked = getBookedCount(dateStr, s.time, s.className);
                      const rem = s.maxCapacity - booked;
                      if (rem > 0) {
                        allFull = false;
                      }
                    });
                  }

                  return (
                    <button
                      key={formatDate(date)}
                      onClick={() => handleDateClick(date)}
                      disabled={!hasClass}
                      className={`h-12 md:h-14 rounded-xl text-sm md:text-base font-bold relative transition-all flex flex-col items-center justify-center gap-0.5 ${
                        isSelected
                          ? 'bg-gradient-to-br from-[#FF6B35] to-[#FF8C5A] text-white shadow-lg scale-105'
                          : !hasClass
                          ? 'text-gray-300 cursor-default'
                          : allFull
                          ? 'text-gray-400 bg-gray-50 cursor-not-allowed opacity-60'
                          : 'text-gray-800 hover:bg-[#FFF5F0] cursor-pointer hover:scale-105'
                      } ${dow === 0 && !isSelected ? '!text-red-300' : ''} ${dow === 6 && !isSelected ? '!text-[#93C5FD]' : ''}`}
                    >
                      <span>{date.getDate()}</span>
                      {hasClass && (
                        <div className="flex gap-0.5">
                          {allFull ? (
                            <span className="text-[8px] md:text-[9px] text-gray-400 font-bold">満席</span>
                          ) : (
                            <div className="w-1.5 h-1.5 rounded-full bg-[#06C755]"></div>
                          )}
                        </div>
                      )}
                    </button>
                  );
                })}
              </div>

              {/* Legend */}
              <div className="flex items-center gap-4 mt-4 pt-4 border-t border-gray-100">
                <div className="flex items-center gap-1.5 text-xs text-gray-500 font-medium">
                  <div className="w-2.5 h-2.5 rounded-full bg-[#06C755]"></div>
                  空きあり
                </div>
                <div className="flex items-center gap-1.5 text-xs text-gray-500 font-medium">
                  <span className="text-[9px] text-gray-400 font-bold">満席</span>
                  空きなし
                </div>
                <div className="flex items-center gap-1.5 text-xs text-gray-500 font-medium">
                  <div className="w-2.5 h-2.5 rounded-full bg-gray-200"></div>
                  休み
                </div>
              </div>
              <div className="mt-3 pt-4 border-t border-gray-100">
                <div className="flex items-start gap-2 text-xs text-gray-600 font-medium bg-[#FFF5F0] px-3 py-2 rounded-lg">
                  <i className="ri-football-line text-[#FF6B35] text-sm mt-0.5"></i>
                  <div>
                    <strong className="text-[#FF6B35]">日曜日のサッカー特別コース</strong>は定員8名です（他クラスは6名）
                  </div>
                </div>
              </div>
            </div>

            {/* Slot Selection & Form */}
            <div className="md:col-span-2 space-y-4">
              {formStep === 'calendar' && (
                <>
                  {/* Selected Date Slots */}
                  {selectedDate ? (
                    <div className="bg-white rounded-2xl md:rounded-3xl p-5 md:p-6 shadow-xl border-2 border-gray-100">
                      <div className="flex items-center gap-2 mb-4">
                        <div className="w-8 h-8 bg-gradient-to-br from-[#FF6B35] to-[#FF8C5A] rounded-lg flex items-center justify-center">
                          <i className="ri-calendar-event-line text-white text-base"></i>
                        </div>
                        <h4 className="font-black text-gray-900 text-base">
                          {selectedDate.getMonth() + 1}月{selectedDate.getDate()}日（{WEEKDAY_LABELS[selectedDate.getDay()]}）
                        </h4>
                      </div>
                      <div className="space-y-3">
                        {getSlotsForDate(selectedDate).map((slot, i) => {
                          const dateStr = formatDate(selectedDate);
                          const booked = getBookedCount(dateStr, slot.time, slot.className);
                          const remaining = slot.maxCapacity - booked;
                          const isFull = remaining <= 0;
                          const isChosen = selectedSlot?.slot === slot && selectedSlot?.date === dateStr;

                          return (
                            <button
                              key={i}
                              onClick={() => handleSlotSelect(slot, remaining)}
                              disabled={isFull}
                              className={`w-full text-left rounded-xl p-3.5 transition-all border-2 ${
                                isChosen
                                  ? 'border-[#FF6B35] bg-[#FFF5F0] shadow-md'
                                  : isFull
                                  ? 'border-gray-100 bg-gray-50 cursor-not-allowed opacity-60'
                                  : 'border-gray-100 hover:border-[#FF6B35]/40 hover:bg-[#FFF5F0]/50 cursor-pointer'
                              }`}
                            >
                              <div className="flex items-center justify-between mb-1.5">
                                <span className={`text-xs font-bold px-2 py-0.5 rounded-md bg-gradient-to-r ${slot.color} text-white`}>
                                  {slot.time}
                                </span>
                                {isChosen && (
                                  <div className="w-5 h-5 flex items-center justify-center">
                                    <i className="ri-check-line text-[#FF6B35] text-lg"></i>
                                  </div>
                                )}
                              </div>
                              <div className="text-sm font-bold text-gray-900 mb-1.5">{slot.className}</div>
                              <div className="flex items-center gap-2">
                                {isFull ? (
                                  <span className="text-xs font-bold text-red-400 bg-red-50 px-2 py-0.5 rounded-md">満席</span>
                                ) : (
                                  <>
                                    <div className="flex-1 h-2 bg-gray-100 rounded-full overflow-hidden">
                                      <div
                                        className={`h-full rounded-full transition-all ${
                                          remaining <= 2 ? 'bg-gradient-to-r from-red-400 to-red-500' : 'bg-gradient-to-r from-[#06C755] to-[#00B900]'
                                        }`}
                                        style={{ width: `${(remaining / slot.maxCapacity) * 100}%` }}
                                      ></div>
                                    </div>
                                    <span className={`text-xs font-black whitespace-nowrap ${remaining <= 2 ? 'text-red-500' : 'text-[#06C755]'}`}>
                                      残り{remaining}名
                                    </span>
                                  </>
                                )}
                              </div>
                            </button>
                          );
                        })}
                      </div>
                      {selectedSlot && (
                        <button
                          onClick={() => setFormStep('form')}
                          className="w-full mt-4 bg-gradient-to-r from-[#FF6B35] to-[#FF8C5A] text-white font-bold py-3.5 rounded-full hover:shadow-xl hover:scale-105 transition-all whitespace-nowrap cursor-pointer shadow-lg text-sm"
                        >
                          この日程で申し込む
                          <i className="ri-arrow-right-line ml-2"></i>
                        </button>
                      )}
                    </div>
                  ) : (
                    <div className="bg-white rounded-2xl md:rounded-3xl p-6 md:p-8 shadow-xl border-2 border-gray-100 text-center">
                      <div className="w-16 h-16 bg-gradient-to-br from-[#FFF5F0] to-[#FFE5D9] rounded-2xl flex items-center justify-center mx-auto mb-4">
                        <i className="ri-calendar-todo-line text-[#FF6B35] text-3xl"></i>
                      </div>
                      <h4 className="font-black text-gray-900 text-base mb-2">日程を選択してください</h4>
                      <p className="text-gray-500 text-sm font-medium">
                        カレンダーから体験したい日をタップすると、その日のクラスと空き状況が表示されます。
                      </p>
                    </div>
                  )}

                  {/* Quick Info */}
                  <div className="bg-[#F0F9FF] rounded-xl p-4 border border-[#0EA5E9]/20">
                    <div className="flex items-start gap-2">
                      <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                        <i className="ri-information-line text-[#0EA5E9] text-base"></i>
                      </div>
                      <div className="text-xs text-gray-600 font-medium space-y-1">
                        <div>・各クラス定員<strong>6名</strong>の少人数制</div>
                        <div>・<strong className="text-[#FF6B35]">⚽日曜サッカー特別コースのみ定員8名</strong></div>
                        <div>・1回<strong>45分</strong>のレッスン</div>
                        <div>・動きやすい服装でお越しください</div>
                        <div>・室内シューズをご持参ください</div>
                      </div>
                    </div>
                  </div>
                </>
              )}

              {/* Booking Form */}
              {formStep === 'form' && selectedSlot && (
                <div className="bg-white rounded-2xl md:rounded-3xl p-5 md:p-6 shadow-xl border-2 border-gray-100">
                  <button
                    onClick={() => setFormStep('calendar')}
                    className="flex items-center gap-1 text-sm text-gray-500 font-bold hover:text-[#FF6B35] transition-colors mb-4 cursor-pointer"
                  >
                    <i className="ri-arrow-left-s-line text-lg"></i>
                    日程選択に戻る
                  </button>

                  {/* Selected Info */}
                  <div className="bg-gradient-to-r from-[#FFF5F0] to-[#FFE5D9] rounded-xl p-4 mb-5">
                    <div className="text-xs text-[#FF6B35] font-bold mb-1">選択中の日程</div>
                    <div className="text-sm font-black text-gray-900">{selectedSlot.dateJP}（{WEEKDAY_LABELS[new Date(selectedSlot.date).getDay()]}）</div>
                    <div className="text-sm font-bold text-gray-700 mt-0.5">{selectedSlot.slot.time} {selectedSlot.slot.className}</div>
                    <div className="text-xs font-bold text-[#06C755] mt-1">残り{selectedSlot.remaining}名</div>
                  </div>

                  <form
                    id="trial-booking-form"
                    data-readdy-form
                    onSubmit={handleSubmit}
                    className="space-y-4"
                  >
                    {/* Hidden fields */}
                    <input type="hidden" name="希望日" value={`${selectedSlot.dateJP}（${WEEKDAY_LABELS[new Date(selectedSlot.date).getDay()]}）`} />
                    <input type="hidden" name="希望クラス" value={`${selectedSlot.slot.time} ${selectedSlot.slot.className}`} />

                    <div>
                      <label className="block text-sm font-bold text-gray-900 mb-1.5">
                        保護者氏名 <span className="text-red-400">*</span>
                      </label>
                      <input
                        type="text"
                        name="保護者氏名"
                        required
                        className="w-full px-4 py-2.5 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#FF6B35]/30 focus:border-[#FF6B35] text-sm font-medium"
                        placeholder="山田 太郎"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-bold text-gray-900 mb-1.5">
                        お子様の名前 <span className="text-red-400">*</span>
                      </label>
                      <input
                        type="text"
                        name="お子様の名前"
                        required
                        className="w-full px-4 py-2.5 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#FF6B35]/30 focus:border-[#FF6B35] text-sm font-medium"
                        placeholder="山田 はなこ"
                      />
                    </div>

                    <div className="grid grid-cols-2 gap-3">
                      <div>
                        <label className="block text-sm font-bold text-gray-900 mb-1.5">
                          学年 <span className="text-red-400">*</span>
                        </label>
                        <select
                          name="学年"
                          required
                          className="w-full px-4 py-2.5 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#FF6B35]/30 focus:border-[#FF6B35] text-sm font-medium bg-white cursor-pointer"
                        >
                          <option value="">選択</option>
                          <option value="年長">年長</option>
                          <option value="小学1年生">小学1年生</option>
                          <option value="小学2年生">小学2年生</option>
                          <option value="小学3年生">小学3年生</option>
                          <option value="小学4年生">小学4年生</option>
                          <option value="小学5年生">小学5年生</option>
                          <option value="小学6年生">小学6年生</option>
                        </select>
                      </div>
                      <div>
                        <label className="block text-sm font-bold text-gray-900 mb-1.5">
                          性別
                        </label>
                        <select
                          name="性別"
                          className="w-full px-4 py-2.5 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#FF6B35]/30 focus:border-[#FF6B35] text-sm font-medium bg-white cursor-pointer"
                        >
                          <option value="">選択</option>
                          <option value="男の子">男の子</option>
                          <option value="女の子">女の子</option>
                        </select>
                      </div>
                    </div>

                    <div>
                      <label className="block text-sm font-bold text-gray-900 mb-1.5">
                        電話番号 <span className="text-red-400">*</span>
                      </label>
                      <input
                        type="tel"
                        name="電話番号"
                        required
                        className="w-full px-4 py-2.5 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#FF6B35]/30 focus:border-[#FF6B35] text-sm font-medium"
                        placeholder="090-1234-5678"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-bold text-gray-900 mb-1.5">
                        メールアドレス <span className="text-red-400">*</span>
                      </label>
                      <input
                        type="email"
                        name="email"
                        required
                        className="w-full px-4 py-2.5 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#FF6B35]/30 focus:border-[#FF6B35] text-sm font-medium"
                        placeholder="example@email.com"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-bold text-gray-900 mb-1.5">
                        ご質問・ご要望
                      </label>
                      <textarea
                        name="ご質問・ご要望"
                        rows={3}
                        maxLength={500}
                        className="w-full px-4 py-2.5 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#FF6B35]/30 focus:border-[#FF6B35] text-sm resize-none font-medium"
                        placeholder="気になることがあればお気軽にどうぞ（500文字以内）"
                      ></textarea>
                    </div>

                    {submitStatus === 'error' && (
                      <div className="bg-red-50 text-red-600 text-sm font-bold px-4 py-3 rounded-xl border border-red-200">
                        <i className="ri-error-warning-line mr-1"></i>
                        送信に失敗しました。もう一度お試しください。
                      </div>
                    )}

                    <button
                      type="submit"
                      disabled={submitStatus === 'submitting'}
                      className="w-full bg-gradient-to-r from-[#FF6B35] to-[#FF8C5A] text-white font-black py-3.5 rounded-full hover:shadow-xl hover:scale-105 transition-all whitespace-nowrap cursor-pointer shadow-lg text-sm disabled:opacity-60 disabled:cursor-not-allowed disabled:hover:scale-100"
                    >
                      {submitStatus === 'submitting' ? (
                        <span className="flex items-center justify-center gap-2">
                          <i className="ri-loader-4-line animate-spin"></i>
                          送信中...
                        </span>
                      ) : (
                        '体験レッスンを申し込む'
                      )}
                    </button>
                  </form>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
